import { render } from "./Workboards.vue?vue&type=template&id=7b6d4962&scoped=true"
import script from "./Workboards.vue?vue&type=script&lang=js"
export * from "./Workboards.vue?vue&type=script&lang=js"

import "./Workboards.vue?vue&type=style&index=0&id=7b6d4962&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6d4962"]])

export default __exports__